module.exports = __webpack_public_path__ + "static/media/navyClose.e2cd1206.svg";